import { DAY_LOWERCASE, MONTH_LOWERCASE } from '../../../constants/common';
import {
  REDUX_KEY_CALCULATED,
  SELECTED_VALUES,
  TVNZ_NETWORK
} from '../../constants';
import { CalculatedSlice } from './types';

const stationLoadingInitialState = {
  [TVNZ_NETWORK.ONE]: 0,
  [TVNZ_NETWORK.TWO]: 0,
  [TVNZ_NETWORK.DUKE]: 0,
  [REDUX_KEY_CALCULATED.TOTAL_STATION_LOADING]: 0
};

const stationSelectedValuesInitialState = {
  [TVNZ_NETWORK.ONE]: 0,
  [TVNZ_NETWORK.TWO]: 0,
  [TVNZ_NETWORK.DUKE]: 0
};

const stationSelectedOptimized = {
  [TVNZ_NETWORK.ONE]: true,
  [TVNZ_NETWORK.TWO]: true,
  [TVNZ_NETWORK.DUKE]: true
};

const daysInitialState = {
  [DAY_LOWERCASE.MONDAY]: 0,
  [DAY_LOWERCASE.TUESDAY]: 0,
  [DAY_LOWERCASE.WEDNESDAY]: 0,
  [DAY_LOWERCASE.THURSDAY]: 0,
  [DAY_LOWERCASE.FRIDAY]: 0,
  [DAY_LOWERCASE.SATURDAY]: 0,
  [DAY_LOWERCASE.SUNDAY]: 0,
  [REDUX_KEY_CALCULATED.TOTAL_DAYS_LOADING]: 0
};

const adMirroringInitialState = {
  [REDUX_KEY_CALCULATED.IS_AD_MIRRORING_ENABLED]: false,
  [REDUX_KEY_CALCULATED.AD_MIRRORING_LOADING]: 0
};

const calculatedValuesInitialState = {
  [SELECTED_VALUES.PEAK]: 0,
  [SELECTED_VALUES.FIBLIB]: 0,
  [REDUX_KEY_CALCULATED.BASE_CPM]: 0,
  [REDUX_KEY_CALCULATED.BASE_CPT]: 0,
  [REDUX_KEY_CALCULATED.PEAK_LOADING]: 0,
  [REDUX_KEY_CALCULATED.STATION_LOADING]: stationLoadingInitialState,
  [REDUX_KEY_CALCULATED.STATION_SELECTED_VALUES]:
    stationSelectedValuesInitialState,
  [REDUX_KEY_CALCULATED.STATION_SELECTED_OPTIMIZED]: stationSelectedOptimized,
  [REDUX_KEY_CALCULATED.DAYS]: daysInitialState,
  [REDUX_KEY_CALCULATED.FIB_LIB_LOADING]: 0,
  [REDUX_KEY_CALCULATED.TOTAL_LOADING]: 0,
  [REDUX_KEY_CALCULATED.TOTAL_CPT]: 0,
  [REDUX_KEY_CALCULATED.TOTAL_CPM]: 0,
  [REDUX_KEY_CALCULATED.TOTAL_TARPS]: 0,
  [REDUX_KEY_CALCULATED.AD_MIRRORING]: adMirroringInitialState
};

const initialState: CalculatedSlice = {
  [MONTH_LOWERCASE.JANUARY]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.FEBRUARY]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.MARCH]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.APRIL]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.MAY]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.JUNE]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.JULY]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.AUGUST]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.SEPTEMBER]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.OCTOBER]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.NOVEMBER]: calculatedValuesInitialState,
  [MONTH_LOWERCASE.DECEMBER]: calculatedValuesInitialState
};

export default initialState;
